__turbopack_context__.v({
  "floating": "TextSection-module-scss-module__rejJmq__floating",
  "rotate": "TextSection-module-scss-module__rejJmq__rotate",
  "text-section": "TextSection-module-scss-module__rejJmq__text-section",
  "text-section--single": "TextSection-module-scss-module__rejJmq__text-section--single",
  "text-section--small": "TextSection-module-scss-module__rejJmq__text-section--small",
  "text-section__content": "TextSection-module-scss-module__rejJmq__text-section__content",
  "text-section__heading": "TextSection-module-scss-module__rejJmq__text-section__heading",
  "text-section__paragraph": "TextSection-module-scss-module__rejJmq__text-section__paragraph",
});
